module.exports = __webpack_public_path__ + "img/presentacion_manual.b22d3499.jpg";